import * as React from "react";
import {cs} from "../../../../../../../../../react/chain-services";
import "./po-box-section.scss";
import {PoBoxTable} from "./po-box-table/po-box-table";

export const PoBoxSection = ({poRoutes, selecteds, next}) => cs(
    ["poBoxTable", ({}, next) => PoBoxTable({poRoutes, selecteds, next})],
    ({poBoxTable}) => next({
        render: ({showErrors}) => (
            <div className="po-box-section-c8p">

                <div className="header">
                    <div className="left">
                        <div className="title" xd-qa-type="label" xd-qa-name="Neighborhood Search PO Box Table Title">
                            PO Box Neighborhood Routes
                        </div>
                    </div>
                    <div className="right">
                        {poBoxTable.renderSearch()}
                    </div>
                </div>

                <div className="box">
                    {poBoxTable.renderTable()}
                    
                    {Instruction({})}
                </div>
            </div>
        ),
    }),
);

const Instruction = ({}) => (
    <div className="instruction" xd-qa-type="label" xd-qa-name="Neighborhood Search PO Box Table Instruction">
        The list may not be copied, duplicated, or transferred. The list may not be used for building or integrating{" "}
        into any other databases. Altering the data may effect your postage rates.
    </div>
);